// Fallback layouts used while a workspace's Control Panel configuration is
// unavailable or incomplete. Keep these definitions aligned with the backend
// defaults because they also drive forms and table rendering.
export const DEFAULT_WORKSPACE_COLUMNS = {
  business_tracker: [
    { key: "status", label: "Status", type: "dropdown", core: true, options: ["Active", "Inactive", "Pending"] },
    { key: "engmt_id", label: "Engmt ID", type: "text", core: true },
    { key: "client_name", label: "Client", type: "text", core: true },
    { key: "process", label: "Process", type: "text", core: true },
    { key: "service", label: "Service", type: "text", core: true },
    { key: "rev_code", label: "Rev Code", type: "text", core: true },
    { key: "fte", label: "FTE", type: "number", core: true, decimals: 2 },
    { key: "pricing", label: "Pricing", type: "currency", core: true, financial: true, decimals: 0 },
    { key: "engmt_type", label: "Type", type: "text", core: true },
    { key: "order_crf_num", label: "CRF #", type: "text", core: true },
    { key: "order_crf_date", label: "CRF Date", type: "date", core: true },
    { key: "start_date", label: "Start", type: "date", core: true },
    { key: "end_date", label: "End", type: "date", core: true },
    { key: "duration_months", label: "Months", type: "number", core: true, decimals: 0 },
    { key: "state", label: "State", type: "text", core: true },
    { key: "specialty", label: "Specialty", type: "text", core: true },
    { key: "billing_system", label: "Billing System", type: "text", core: true },
    { key: "poc", label: "POC", type: "text", core: true },
    { key: "notes", label: "Notes", type: "text", core: true },
  ],
  revenue_details: [
    { key: "reporting_month", label: "Month", type: "date", core: true },
    { key: "client_name", label: "Client", type: "text", core: true },
    { key: "service", label: "Service", type: "text", core: true },
    { key: "process", label: "Process", type: "text", core: true },
    { key: "rev_code", label: "Rev Code", type: "text", core: true },
    { key: "pricing", label: "Pricing", type: "currency", core: true, financial: true, decimals: 2 },
    { key: "billable_ftes", label: "Billable FTE", type: "number", core: true, decimals: 2 },
    { key: "prorated_ftes", label: "Prorated FTE", type: "number", core: true, decimals: 2 },
    { key: "invoice_amount", label: "Invoice Amount", type: "currency", core: true, financial: true, decimals: 2 },
    { key: "remarks", label: "Remarks", type: "text", core: true },
  ],
  services: [
    { key: "process", label: "Process", type: "text", core: true },
    { key: "service", label: "Service", type: "text", core: true },
    { key: "service_code", label: "Service Code", type: "text", core: true },
    { key: "rev_code", label: "Rev Code", type: "text", core: true },
    { key: "pricing", label: "Pricing", type: "currency", core: true, financial: true, decimals: 2 },
  ],
};

const isValidWorkspaceColumn = (column) => (
  column
  && typeof column === "object"
  && !Array.isArray(column)
  && typeof column.key === "string"
  && column.key.trim().length > 0
);

/**
 * Return the workspace layout with required core columns restored.
 *
 * Valid configured columns remain in their configured order and retain their
 * labels and other settings. Missing defaults are appended in default order.
 */
export const getEffectiveWorkspaceColumns = (tableKey, configuredColumns) => {
  const defaultColumns = DEFAULT_WORKSPACE_COLUMNS[tableKey] || [];
  const validConfiguredColumns = Array.isArray(configuredColumns)
    ? configuredColumns.filter(isValidWorkspaceColumn)
    : [];

  if (validConfiguredColumns.length === 0) return defaultColumns;

  const configuredKeys = new Set(validConfiguredColumns.map((column) => column.key));
  return [
    ...validConfiguredColumns,
    ...defaultColumns.filter((column) => !configuredKeys.has(column.key)),
  ];
};